import {Trans} from 'react-i18next';
import {TextHighlight} from '@chekinapp/ui';

export type HighlightedTitleTone = 'brand' | 'error' | 'success';

const TONE_CLASS: Record<Exclude<HighlightedTitleTone, 'brand'>, string> = {
  error: 'text-[var(--chekin-red-soft)]',
  success: 'text-[var(--chekin-green-700)]',
};

type HighlightedTitleProps = {
  i18nKey: string;
  tone?: HighlightedTitleTone;
  values?: Record<string, unknown>;
  ns?: string;
};

export function HighlightedTitle({
  i18nKey,
  tone = 'brand',
  values,
  ns,
}: HighlightedTitleProps) {
  return (
    <Trans
      ns={ns}
      i18nKey={i18nKey}
      values={values}
      components={{
        1: tone === 'brand' ? <TextHighlight /> : <span className={TONE_CLASS[tone]} />,
      }}
    />
  );
}
